module.exports = __webpack_public_path__ + "img/gpu_cover_sag.596da930.png";